export const gtm =
  '<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WFXQTQX" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>';
